import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

// Components
import AlertMessage from '@components/individualPortal/dashboard/AlertMsgs/AlertMessage';

// Constants
import { ALERT_TYPES } from '@constants/individualPortal/dashboard/dashboardModelTypes';

// Configs
import { configs } from '@constants/configs/configs';

const AssociationAlertStyled = styled(AlertMessage)`
    width: 100%;
    margin-bottom: 20px;
  
    .gi-alert svg {
          transform: scale(2);
          margin-right: 25px;
    }
    
    .usa-alert__text a {
      color: #91350A;
    }
          
`;

const AssociationAlert = ({ associationAlertTypeKey, name }) => {
    return (
        <AssociationAlertStyled
            content={<FormattedMessage
                id={associationAlertTypeKey}
                values={{
                    name: name,
                    lineBreak:  <br />,
                    link: <a href={configs.routes.ANON_GA_GAEPS }>
                        <FormattedMessage id="ga.association_alert.partner_link" values={{ name }}/>
                    </a>
                }}/>}
            type={ALERT_TYPES.INFO}
            showIcon={true}
            icon={faExclamationTriangle}
        />
    );
};

export default AssociationAlert;